import React from 'react';

import { cn } from '@/lib/utils';

import { mutualLinkStyle } from '@/decodo/blocks/Footer';
import {
  PopupImageLinkStrapi,
  PopupImageLinkStrapiBlock,
} from '@/decodo/components/atoms/PopupImageLink/PopupImageLinkStrapi';
import { Text } from '@/decodo/components/atoms/Text';

const getGridTemplatePosition = (index: number) => {
  return [
    'col-start-1 row-start-1',
    'col-start-1 row-start-2',
    'col-start-2 row-start-1 row-span-2',
  ][index];
};

type FooterContact = {
  title: string;
  links: PopupImageLinkStrapiBlock[];
};

export type FooterContactsProps = {
  contacts: FooterContact[];
};

const FooterContacts = ({ contacts }: FooterContactsProps) => {
  return contacts.map((contact, index) => {
    // in the unlikely scenario we will go with a mix of text/img variants,
    // if at least one link entry contains text, the entire section will be rendered as a list
    const shouldRenderAsList = contact.links.find((link) => !!link.link?.text);

    return (
      <div
        key={index}
        className={cn('flex flex-col gap-8', getGridTemplatePosition(index))}
      >
        <Text
          classNames={{
            wrapper:
              'text-label-medium text-gray-500 dark:text-gray-dark-400 font-serif',
          }}
        >
          {contact.title}
        </Text>
        <div
          className={cn(
            mutualLinkStyle,
            'max-w-max gap-4',
            shouldRenderAsList
              ? 'flex flex-col flex-wrap gap-x-4 gap-y-3'
              : 'grid grid-cols-4 gap-y-4'
          )}
        >
          {contact.links.map((link, index) => (
            <PopupImageLinkStrapi
              key={index}
              block={link}
              inner={{
                link: {
                  variant: 'text',
                  slim: true,
                  'data-tracker-context': `${index}`,
                  classNames: {
                    root: mutualLinkStyle,
                  },
                },
                popup: {
                  showArrow: true,
                  position: 'right',
                  classNames: {
                    childrenWrapper: 'h-[7.5rem] w-[7.5rem] p-2.5 border-none',
                  },
                },
                image: {
                  classNames: {
                    image: 'w-6 h-6',
                  },
                },
              }}
            />
          ))}
        </div>
      </div>
    );
  });
};

export default FooterContacts;
